import {
    TokenTimeseriesColumns,
    TokenTimeseriesGroupBy,
} from "~/modules/token_timeseries/types";
import {
    AggregateFunctions,
    AggregateQueryMode,
    ApiQueryEndpoints,
    Filter,
    FilterOperators,
} from "~/modules/filters/types";
import {
    BooleanControlState,
    LegendProps,
    NavigatorControlState,
    VisualizationConfig,
    VisualizationMode,
    VisualizationModeTypes,
} from "~/modules/visualization/components/Timeseries/types";
import {
    DEFAULT_STACKED_CONTROLS,
    TOKEN_TIMESERIES_V4_API_TOOLS_CONTROLS,
} from "~/modules/visualization/components/Timeseries/consts";
import { ExportTableNames } from "~/modules/downloads/types";

// // // //

const visualizationConfig: VisualizationConfig = {
    area: true,
    enableZoom: false,
    showTotal: true,
    height: 350,
    legend: {
        itemWidth: 125,
        layout: "vertical",
        align: "right",
        verticalAlign: "top",
    },
};

// // // //

export function getAllTokensStackedChart(props: {
    key: string;
    description?: string;
    label: string;
    filters: Filter[];
    defaultGroupBy: TokenTimeseriesGroupBy;
    groupByForceUpdate?: boolean;
    groupLimit?: number;
    enableGroupByControls: boolean;
    groupByOptions: TokenTimeseriesGroupBy[];
    measureSlug: string;
    loginRequired?: boolean;
    ignoreDownloadsFeatureFlag?: boolean;
    legend?: LegendProps;
    navigator?: NavigatorControlState;
    stacked?: BooleanControlState;
    height?: number;
}): VisualizationMode {
    const {
        key,
        description,
        label,
        filters,
        enableGroupByControls = true,
        defaultGroupBy = TokenTimeseriesGroupBy.asset,
        groupByForceUpdate = true,
        groupLimit,
        measureSlug = null,
        ignoreDownloadsFeatureFlag = false,
        groupByOptions,
        loginRequired = false,
        legend = visualizationConfig.legend,
        navigator = {
            active: true,
            enabled: true,
            forceUpdate: true,
        },
        stacked = DEFAULT_STACKED_CONTROLS,
        height,
    } = props;

    const measureFilter = {
        field: TokenTimeseriesColumns.measureSlug,
        operator: FilterOperators.Equals,
        value: measureSlug,
    };

    return {
        key,
        type: VisualizationModeTypes.area,
        content: {
            label,
            description,
        },
        queryControls: {
            groupBy: {
                enabled: enableGroupByControls,
                forceUpdate: groupByForceUpdate,
                value: defaultGroupBy,
                allowedOptions: groupByOptions,
            },
        },
        loginRequired,
        visualizationConfig: {
            ...visualizationConfig,
            legend,
            ...(height !== undefined && { height }),
        },
        visualizationControls: {
            navigator: {
                ...navigator,
            },
            stacked: {
                ...stacked,
            },
        },
        endpoint: ApiQueryEndpoints.TokenTimeseriesV4,
        query: {
            aggregate: {
                aggregateFunction: AggregateFunctions.Sum,
                groupBy: TokenTimeseriesGroupBy.asset,
                mode: AggregateQueryMode.stock,
                groupLimit,
            },
            filter: {
                operator: FilterOperators.And,
                filters: [...filters, measureFilter],
            },
            sort: {
                direction: "asc",
                field: "date",
            },
            pagination: {
                page: 1,
                perPage: 25,
            },
        },
        apiTools: TOKEN_TIMESERIES_V4_API_TOOLS_CONTROLS,
        dataExportControls: {
            enabled: true,
            filename: key,
            ignoreFeatureFlag: ignoreDownloadsFeatureFlag,
            exportTableName: ExportTableNames.token_timeseries_v4,
        },
    };
}
